import { ref } from 'vue'
import {toast} from "vue3-toastify";

interface ToastOptions {
  timeout?: number
  color?: string
  icon?: string
}

export function useToast() {
  const toast = ref<{
    show: boolean
    message: string
    color: string
    icon: string
    timeout: number
  }>({
    show: false,
    message: '',
    color: 'success',
    icon: 'mdi-check-circle',
    timeout: 3000
  })

  function showToast(message: string, options: ToastOptions = {}) {

    toast.value = {
      show: true,
      message,
      color: options.color || 'success',
      icon: options.icon || 'mdi-check-circle',
      timeout: options.timeout || 3000
    }
  }

  function showSuccess(message: string, options: ToastOptions = {}) {
    showToast(message, {
      color: 'success',
      icon: 'mdi-check-circle',
      ...options
    })
  }

  function showError(message: string, options: ToastOptions = {}) {
    showToast(message, {
      color: 'error',
      icon: 'mdi-alert-circle',
      ...options
    })
  }

  function showWarning(message: string, options: ToastOptions = {}) {
    showToast(message, {
      color: 'warning',
      icon: 'mdi-alert',
      ...options
    })
  }

  function showInfo(message: string, options: ToastOptions = {}) {
    showToast(message, {
      color: 'info',
      icon: 'mdi-information',
      ...options
    })
  }

  return {
    toast,
    showToast,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
} 